var primaryMenu = document.querySelector('#menu-menu-primary');
var overlay = document.querySelector('.menu-back-overlay');
var liLvl0Arr = document.querySelectorAll('#menu-menu-primary .li-level-0');
var liLvl1Arr = document.querySelectorAll('#menu-menu-primary .li-level-1');
var liLvl2Arr = document.querySelectorAll('#menu-menu-primary .li-level-2');
var liLvl3Arr = document.querySelectorAll('#menu-menu-primary .li-level-3');

var hamburger = document.querySelector('#hamburger');
var dropdownBar = document.querySelector('.dropdown-bar');
var closeMobileMenu = document.querySelector('.close-mobile-menu');

var mediaQuery = window.matchMedia('(min-width: 1024px)');
primaryMenu.childNodes[0].classList.add('mega-menu');

var desktopMenuSearch = document.querySelector('.dgwt-wcas-search-input');
var mobileMenuSearch = document.querySelector('.mobile-menu-search-input');

var searchMediaQuery = window.matchMedia('(min-width: 640px)');

// Initial check

function handleSearchChange(e) {
    // Check if the media query is true
    if (e.matches) {
        mobileMenuSearch.id = 'placeholder-id-001';
        desktopMenuSearch.id = 'dgwt-wcas-search-input-1';
    } else {
        desktopMenuSearch.id = 'placeholder-id-000';
        mobileMenuSearch.id = 'dgwt-wcas-search-input-1';
    }
}
handleSearchChange(searchMediaQuery);
searchMediaQuery.addListener(handleSearchChange);

var aLvl0Arr = [];
var aLvl1Arr = [];
var aLvl2Arr = [];
var aLvl3Arr = [];
var ulLvl0Arr = [];
var ulLvl1Arr = [];
var ulLvl2Arr = [];

// Red navi bar markup
var contactMarkup = `<div class="contact-red-box hide-for-large" >
                <div class="call-us">
                    For help or advice call
                    <span>
					0808 1750215
                    </span>
                </div>
                <div class="social-icons">
                    <ul class="social-icons--list">
                        <li> <a href="https://www.facebook.com/CWPlantHire/?fref=ts"><i
                                    class="fab fa-facebook"></i>
                            </a></li>
                       
                        <li><a href="https://www.linkedin.com/company/charles-wilson-eng-ltd"><i
                                    class="fab fa-linkedin-in"></i></a></li>
                    </ul>
                </div>
            </div>`;

liLvl0Arr.forEach(li => aLvl0Arr.push(li.childNodes[0]));
liLvl1Arr.forEach(li => aLvl1Arr.push(li.childNodes[0]));
liLvl2Arr.forEach(li => aLvl2Arr.push(li.childNodes[0]));
liLvl3Arr.forEach(li => aLvl3Arr.push(li.childNodes[0]));

liLvl0Arr.forEach(li =>
    li.childNodes[2] ? ulLvl0Arr.push(li.childNodes[2]) : null
);
liLvl1Arr.forEach(li =>
    li.childNodes[2] ? ulLvl1Arr.push(li.childNodes[2]) : null
);
liLvl2Arr.forEach(li =>
    li.childNodes[2] ? ulLvl2Arr.push(li.childNodes[2]) : null
);

function resetWidth(menuItemArr) {
    menuItemArr.forEach(el => (el.style.width = ''));
}

//  insert category label (only for mobile menu)
aLvl0Arr.forEach(a =>
    a.nextElementSibling && a.nextElementSibling.nodeName === 'UL' ?
    a.nextElementSibling.insertAdjacentHTML(
        'afterbegin',
        `<h7 class='menu-category-label hide-for-large'>${a.innerText}</h7>`
    ) :
    null
);

primaryMenu.insertAdjacentHTML('beforeend', contactMarkup);
var redBox = document.querySelector('.contact-red-box');

//  insert category label (for both menus)
aLvl1Arr.forEach(a =>
    a.nextElementSibling && a.nextElementSibling.nodeName === 'UL' ?
    a.nextElementSibling.insertAdjacentHTML(
        'afterbegin',
        `<h7 class='menu-category-label '>${a.innerText}</h7>`
    ) :
    null
);




// Add arrows for elements with children (level 0)
aLvl0Arr.forEach(a =>
    a.nextElementSibling && a.nextElementSibling.nodeName === 'UL' ?
    a.insertAdjacentHTML(
        'beforeend',
        '<i class="far fa-chevron-down show-for-large"></i><i class="far fa-chevron-right hide-for-large"></i>'
    ) :
    null
);
// Add arrows for elements with children (level 1 + 2)
// [...aLvl1Arr, ...aLvl2Arr].forEach(a =>
[...aLvl1Arr].forEach(a =>
    a.nextElementSibling && a.nextElementSibling.nodeName === 'UL' ?
    a.insertAdjacentHTML('beforeend', '<i class="far fa-chevron-right">') :
    null
);


//
hamburger.addEventListener('click', e => {
    e.preventDefault();
    dropdownBar.classList.remove('show-for-large');
    window.addEventListener('scroll', noScroll);
});

closeMobileMenu.addEventListener('click', e => {
    e.preventDefault();
    ulLvl1Arr.forEach(a => a.classList.add('hidden'));
    ulLvl0Arr.forEach(a => a.classList.add('hidden'));
    dropdownBar.classList.add('show-for-large');
    redBox.classList.remove('hidden');
    window.removeEventListener('scroll', noScroll);
});

// Register event listener
mediaQuery.addListener(handleMobileChange);

// Initial check
handleMobileChange(mediaQuery);

function noScroll() {
    window.scrollTo(0, 0);
}

function handleDesktop() {
    var backto = document.querySelectorAll('.back-to');

    aLvl3Arr.forEach(a => {
        if (!a.classList.contains('menu-image-title-below')) {
            a.classList.add('menu-image-title-below', 'menu-image-not-hovered');
            const prodName = a.innerText;
            a.innerText = '';
            a.insertAdjacentHTML(
                'beforeend',
                `
          <img width="251" height="251" src="https://www.velocarnac.com/wp-content/uploads/woocommerce-placeholder-256x256.png" class="menu-image menu-image-title-below" alt="" loading="lazy"><span class="menu-image-title-below menu-image-title">${prodName}</span>`
            );
        } else {
            null;
        }
    });

    backto.length > 0 ? backto.forEach(el => el.remove()) : null;
    ulLvl1Arr.forEach(a => a.classList.remove('hidden'));
    ulLvl0Arr.forEach(a => a.classList.remove('hidden'));
    //Getting menu to display first item by default
    ulLvl1Arr[0].classList.add('pre-select');
    ulLvl1Arr[0].classList.add('pre-select');

    ulLvl0Arr[0].children[1].children[0].classList.add('parent-link');;

    // add overlay on hover

    primaryMenu.addEventListener('mouseenter', () => {
        overlay.classList.remove('hidden');
    });
    // remove overlay on mouseleave
    primaryMenu.addEventListener('mouseleave', () => {
        overlay.classList.add('hidden');
    });

    liLvl0Arr.forEach(el =>
        el.addEventListener('mouseenter', () => {
            el.children[0].insertAdjacentHTML(
                'afterbegin',
                '<hr class="nav-underline">'
            );

            el.children[1].children.classList.add('parent-link');
        })
    );
    liLvl0Arr.forEach(el =>
        el.addEventListener('mouseleave', () => {
            el.children[0].children[0].remove();
        })
    );
    // liLvl0Arr.forEach(el =>
    //   el.addEventListener('mouseleave', () => {
    //     overlay.classList.add('hidden');
    //   })
    // );
    // Highlight parent element

    ulLvl1Arr.forEach(el => {

        // console.log(el.children[1].children[0]);

        // el.children[1].children[0].classList.add('parent-link');


        // console.log(el.children[1].children[0]);

        el.children[1].children[0].classList.add('parent-link');

    });
    ulLvl1Arr.forEach(el => {
        el.addEventListener('mouseenter', () => {
            el.children[1].children[0].classList.remove('parent-link');

            el.previousElementSibling.classList.add('parent-link');
        });
    });


    // Highlight parent element
    ulLvl1Arr.forEach(el => {
        el.addEventListener('mouseleave', () => {
            el.children[1].children[0].classList.add('parent-link');
            el.previousElementSibling.classList.remove('parent-link');
        });
    });
    ulLvl2Arr.forEach(el => {
        el.addEventListener('mouseenter', () => {
            el.previousElementSibling.classList.add('parent-link');
        });
    });
    ulLvl2Arr.forEach(el => {
        el.addEventListener('mouseleave', () => {
            el.previousElementSibling.classList.remove('parent-link');
        });
    });

    // Insert view all link
    // aLvl2Arr.forEach(a =>
    //     a.nextElementSibling && a.nextElementSibling.nodeName === 'UL' ?
    //     a.nextElementSibling.insertAdjacentHTML(
    //         'beforeend',
    //         `<div class="view-all-box" ><hr><a href="${a.href}" class='view-all-link'>view all</a></div>`
    //     ) :
    //     null
    // );
}

function handleMobile() {
    ulLvl1Arr[0].classList.remove('pre-select');

    ulLvl1Arr.forEach(a => a.classList.add('hidden'));
    ulLvl0Arr.forEach(a => a.classList.add('hidden'));
    resetWidth(aLvl0Arr);

    aLvl0Arr.forEach(a =>
        a.nextElementSibling && a.nextElementSibling.nodeName === 'UL' ?
        a.nextElementSibling.insertAdjacentHTML(
            'afterbegin',
            `<a href="#" class='back-to back-to-main'><i class="far fa-chevron-left"></i>Back to main menu</a>`
        ) :
        null
    );

    aLvl1Arr.forEach(a =>
        a.nextElementSibling && a.nextElementSibling.nodeName === 'UL' ?
        a.nextElementSibling.insertAdjacentHTML(
            'afterbegin',
            `<a href="#" class='back-to back-to-level-1'><i class="far fa-chevron-left"></i>Back to ${a.parentNode.parentNode.parentNode.childNodes[0].innerText.toLowerCase()}</a>`
        ) :
        null
    );

    var backto = document.querySelectorAll('.back-to');
    backto.forEach(btn => {
        btn.addEventListener('click', event => {
            event.preventDefault();
            btn.parentNode.classList.add('hidden');
            btn.parentNode.parentNode.parentNode.id === 'menu-menu-primary' ?
                redBox.classList.remove('hidden') :
                null;
        });
    });
    [...aLvl0Arr, ...aLvl1Arr].forEach(a => {
        a.nextElementSibling && a.nextElementSibling.nodeName === 'UL' ?
            a.addEventListener('click', event => {
                event.preventDefault();
                a.nextElementSibling.classList.remove('hidden');
                redBox.classList.add('hidden');
            }) :
            null;
    });
}

function handleMobileChange(e) {
    // Check if the media query is true
    if (e.matches) {
        handleDesktop();
    } else {
        handleMobile();
    }
}